// components/MediaTypeChip.jsx — Anamoria SPA
// v1.1 — NEW-163 Increment B (2026-10-30): `Glyph` is exported (named) with an optional `size`
//   (default 12, unchanged) so the group-note Respond row (GroupNoteBanner v1.2) draws the exact
//   same four glyphs at 15px — one definition, per plan v0.5 §9.2 (icons = the footer glyphs;
//   provisional, cosmetic). The chip itself is byte-identical. NEW-164's footer placement is
//   superseded by this increment: the chip now lives in the response-card header (GroupMemoryCard).
// v1.0 — Group-feed media-type chip (NEW-164, 2026-10-25).
//   A small icon + label (Voice / Video / Photo / Note) shown on GROUP-space
//   feed cards so a mixed set of entry types reads at a glance. Group spaces
//   only — the caller gates on spaceIsGroup; this component is presentational,
//   no data fetch, no behaviour. Returns null for an unknown category.

const META = {
  voice: 'Voice',
  video: 'Video',
  photo: 'Photo',
  text: 'Note',
};

export function Glyph({ category, size = 12 }) {
  const p = {
    width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
    stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round',
    'aria-hidden': true,
  };
  if (category === 'voice') {
    return (<svg {...p}><path d="M12 2v10" /><path d="M8 6a4 4 0 0 0 8 0" /><path d="M5 11a7 7 0 0 0 14 0" /><path d="M12 18v4" /></svg>);
  }
  if (category === 'video') {
    return (<svg {...p}><rect x="3" y="6" width="13" height="12" rx="2" /><path d="M16 10l5-3v10l-5-3" /></svg>);
  }
  if (category === 'photo') {
    return (<svg {...p}><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="9" cy="9" r="2" /><path d="m21 15-4.5-4.5L7 20" /></svg>);
  }
  // text / note
  return (<svg {...p}><path d="M5 7h14" /><path d="M5 12h14" /><path d="M5 17h9" /></svg>);
}

export default function MediaTypeChip({ category }) {
  const key = (category || '').toLowerCase();
  const label = META[key];
  if (!label) return null;
  return (
    <span
      className="mediaTypeChip"
      aria-label={`${label} memory`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 11,
        lineHeight: 1,
        color: '#5A635C',
        background: '#F2EEE6',
        borderRadius: 999,
        padding: '3px 9px',
        whiteSpace: 'nowrap',
      }}
    >
      <Glyph category={key} />
      {label}
    </span>
  );
}
